module.exports = __webpack_public_path__ + "static/media/ml2.65b8d431.jpg";